import React from 'react';
import Modal from 'react-modal';
// import style from './style.module.scss';
import useModalStore from 'hooks/useModalStore';
import { observer } from 'mobx-react';
import CloseImage from 'images/sports/common/close.png';
import clsx from 'clsx';
import style from './style.module.scss';

Modal.setAppElement('#root');

const GoLoginModal = observer(({ option }) => {
  const modalStore = useModalStore();

  if (!option) {
    return <></>;
  }

  const onClickGoLogin = () => {
    let originURL = 'https://named.com/account/login_popup.php';

    if (
      window.location.hostname === 'localhost' ||
      window.location.hostname.includes('dev')
    ) {
      originURL = 'http://dev.named.com/account/login_popup.php';
    }

    window.popupWindow = window.open(
      originURL,
      'loginPopup',
      'menubar=1,width=570,height=800,left=' +
        parseInt(window.outerWidth / 2 - 295) +
        ',top=50'
    );
    modalStore.closeModal();
  };

  return (
    <Modal
      isOpen={option.isOpen}
      onRequestClose={() => {
        modalStore.closeModal();
      }}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          height: 246,
          width: 400,
          marginRight: '-50%',
          padding: 0,
          transform: 'translate(-50%, -50%)',
          borderRadius: 0
        }
      }}
      overlayClassName={style.overlay}
    >
      <div className={style.header}>
        <h2>안내</h2>
        <button onClick={modalStore.closeModal}>
          <img src={CloseImage} alt="닫기" />
        </button>
      </div>
      <div className={style.content}>
        <span className={style.title}>
          해당 서비스는 로그인 후 이용하실 수 있습니다.
        </span>
        <span className={style.subTitle}>
          로그인 화면으로 이동하시겠습니까?
        </span>

        <div className={style.action}>
          <button
            className={clsx(style.btn, style.login)}
            onClick={onClickGoLogin}
          >
            로그인
          </button>
          <button
            className={clsx(style.btn, style.cancel)}
            onClick={modalStore.closeModal}
          >
            취소
          </button>
        </div>
      </div>
    </Modal>
  );
});

export { GoLoginModal };
